import { v4 } from "uuid";
const initSeon = () => {
  if (window.seon) {
    window.seon.config({
      session_id: v4(),
      audio_fingerprint: true,
      canvas_fingerprint: true,
      webgl_fingerprint: true,
      onSuccess(message) {
        console.log("success", message);
      },
      onError(message) {
        console.log("error", message);
      }
    });
  }
};
export {
  initSeon
};
